<template>
  <section id="nomination_single_page"
  :class="$mq">

    <h3 class="section_title">Nominate</h3>
    
    <!-- <div>
      <p>Contest ID: {{instance_contestid}}</p>
      <p>Contest: {{contest}}</p>
    </div> -->

    <div class="noms_active"
    v-if="instance_period == 'Nomination Period'"
    >
      <p>
        Type the name of a person, place, business, event, etc. below and then smash that "nominate" button. 
      </p>
    </div>
    
    <div class="noms_not_active"
    v-if="instance_period != 'Nomination Period'"
    >
      
      <p>
        Nominations are not currently open. Get the latest info on our homepage by tapping the Dayton.com logo at the top of this page.
      </p>

      <p>
        Or check out some of our latest content on Dayton.com:
      </p>

      <story-list
      cms_list_id='69728dd0-6965-11e6-ab50-bec7bcde827e'
      ></story-list>

    </div>

    <div class="nomination_container"
    v-if="instance_period == 'Nomination Period'"
    >
      
      <trans-zoom>

        <!-- LOGIN PROMPT FOR NON-LOGGED-IN USERS -->
        <login-prompt
        v-if="!is_logged_in"
        ></login-prompt>

        <!-- NOMINATION CARD CONTAINER FOR LOGGED-IN USERS ONLY -->
        <div class="nomination_card_outer_container"
        v-if="is_logged_in"
        >

          <!-- LARGE NOMINATION CARD -->
          <nominate-card-large
          v-if="contest"
          :instance_contestid="instance_contestid"
          :contest="contest"
          :nomination_save_status="nomination_save_result"
          :nomination_save_in_progress="nomination_save_in_progress"
          :reset_nomination_requested="reset_nomination"
          @record_nomination_from_contest="nomination_listener"
          @request_nomination_reset="reset_nomination_status"
          ></nominate-card-large>

        </div>

      </trans-zoom>

      <!-- BACK TO NOMINATION LIST -->
      <p class="text-center">
        <button class="btn" type="button"
        @click="goto_path('/nominate')">View All Contests</button>
      </p>

    </div>
    
  </section>
</template>

<script>
import NominateCardLarge from '@/features/nominate/nominate_card_large.vue';
import StoryList from '@/components/lists/story_list.vue';
import LoginPrompt from '@/features/login/login_prompt.vue';
import contestant_list from '@/json/sample_contestant_list.json';
import TransZoom from '@/components/transitions/trans_zoom.vue';
import TransBounce from '@/components/transitions/trans_bounce_inL_outR.vue';

export default {
  name: 'nomination_single_page',
  data () {
    return {
      nomination_details: {},
      nomination_save_result: false,
      nomination_save_in_progress: false,
      reset_nomination: false,
      show_contest_index: 0,
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      nomination_period_started: true,
      meta_title: 'Nominations',
      meta_image: 'https://www.dayton.com/rf/image_large/Pub/p10/Dayton/2019/11/08/Images/DDC_BestofDayton_LeadRelatedObject_169.jpg',
      meta_data: ''
    }
  },
  created() {
    // console.log('nom page created: ');
  },
  mounted() {
    // this.determine_chartbeat();
    // console.log('nom page mounted: ');
  },
  beforeUpdate() {
    // console.log('nom page beforeUpdate: ');
  },
  updated() {
    // console.log('nom page update: ');
    // console.log('this.contest: ', this.contest);
  },
  destroyed() {
    // this.$root.store.nominations.change_single_nom_share_status(false);
  },
  watch: {
    contest: function(new_val, old_val) {
      let vm = this;
      
      if(new_val != old_val) {
        if(new_val) {
          
          if(vm.contest.label) {
            // vm.meta_title = vm.contest.label;
            vm.$set(vm, 'meta_title', vm.contest.label);
            vm.determine_chartbeat();
          }
          
          if(vm.contest.lead_image) {
            // vm.meta_image = vm.contest.lead_image;
            vm.$set(vm, 'meta_image', vm.contest.lead_image);
          }

          // vm.meta_data = vm.contest;
          vm.$set(vm, 'meta_data', vm.contest);

          setTimeout(function() {
            document.dispatchEvent(new Event('prerender-trigger'));
          }, 500)
          
        }
      }
    }
  },
  computed: {
    instance_period: function() {
      return this.$root.store.instances.state.active_instance_period;
    },
    instance_contestid: function() {
      return this.$route.params.id;
    },
    temp_master: function() {
      return this.$root.store.contests.state.master_contest_list;
    },
    is_logged_in: function() {
      return this.$root.store.session.check_login_status();
    },
    contest: function() {
      return this.$root.store.contests.get_single_contest(this.instance_contestid);
    },
    test: function() {
      return 'testing';
    }
  },
  methods: {
    goto_path: function(path_name, param) {
      this.$root.store.goto_path(path_name, param);
    },
    reset_nomination_status() {
      this.nomination_save_result = false;
      // this.nomination_save_in_progress = false;
      this.$set(this, 'nomination_save_in_progress', false);
      this.reset_nomination = false;
    },
    nomination_listener(nomination_text) {
      let vm = this;

      // SET LOCAL VARS WITH NOMINATION DETAILS
      // vm.nomination_details.nomination_text = nomination_text;
      vm.$set(vm.nomination_details, 'nomination_text', nomination_text);
      // vm.nomination_details.contest = vm.contest;
      vm.$set(vm.nomination_details, 'contest', vm.contest);

      // BUILD DATA OBJECT FOR SAVING
      let data = {
        instance_contestid: vm.instance_contestid,
        nomination_text: nomination_text,
        user_publicid: this.$root.store.session.get_userid()
      }

      // SET NOMINATION SAVE TO IN PROGRESS
      vm.nomination_save_in_progress = true;

      // REQUEST NOMINATION SAVE
      vm.$root.store.nominations.record_nomination(data)
        .then(function(response) {
          // console.log('response: ', response);

          // RESET IN PROGRESS STATUS
          vm.nomination_save_in_progress = false;

          if(response.data.data.success === true) {
            vm.nomination_save_result = true;
            vm.$set(vm, 'nomination_save_result', true);

            // FIRE GA EVENT
            vm.$ga.event({
              eventCategory: 'Nominations',
              eventAction: vm.contest.label,
              eventLabel: vm.nomination_details.nomination_text
            })

            // SET TIMER TO RESET NOMINATION
            setTimeout(function() {
              vm.$set(vm, 'reset_nomination', true);
            }, 2000);
            
          }
        })
      
    },
    run_chartbeat: function() {
      window.updateChartbeat(document.title, window.location.pathname);
    },
    determine_chartbeat: function() {
      let vm = this;
      let page_title = document.title;
      
      if(page_title.indexOf(vm.$metaInfo.title) == 0) {
        vm.run_chartbeat();
      }
      else {
        setTimeout(function() {
          vm.determine_chartbeat();
        }, 500);
      }
    }
  },
  metaInfo() {
    return {
      title: this.meta_title,
      titleTemplate: '%s | Best of Dayton 2019',
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: 'Nominate for "'+this.meta_title+'" in the Dayton.com 2019 Best of Dayton contest'
        },
        {
          property: 'og:image',
          content: this.meta_image
        }
      ]
    }
  },
  components: {
    NominateCardLarge,
    LoginPrompt,
    TransZoom,
    TransBounce,
    StoryList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

#nomination_single_page {

  &.desktop, &.laptop {
    width: 50%;
    max-width: 600px;
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/NominationSinglePage.vue